import { ESTILOS_MODAL_DDJJ } from '../constants/modal-carga-ddjj.js'

// Combina por componente: `{ alerta: { variant: 'info' } }` cambia sólo la variante de la
// alerta y deja el resto de sus props y de los demás componentes como en ESTILOS_MODAL_DDJJ.
// Una prop que se pasa reemplaza a la de defecto (className incluido, no se concatena).
export function combinarEstilosDdjj(estilos = {}) {
  return Object.fromEntries(
    Object.entries(ESTILOS_MODAL_DDJJ).map(([clave, porDefecto]) => [clave, { ...porDefecto, ...estilos[clave] }])
  )
}
